// extracted by mini-css-extract-plugin
export default {"carousel":"o3gf3"};